<template>
  <base-event-log-item
    :icon="icon"
    :icon-color="iconColor"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
  >
    <div class="text-overflow-ellipsis">
      <span class="font-weight-medium">Tag</span>
      <span class="font-weight-light">
        {{ verbs }}
      </span>
    </div>
    <template #append>
      <reference-tag-chip
        :label="tagLabel"
        :color="tagColor"
        :strike="strike"
        class="white--text my-2"
      />
    </template>
  </base-event-log-item>
</template>
<script>
import BaseEventLogItem from './BaseEventLogItem';
import ReferenceTagChip from '@/components/References/ReferenceTagChip';
import { ReferenceEventLog, Reference } from '@/models';
import { ReferenceEvent } from '@/enums';

const EVENT_TO_STYLE_PROPS = {
  [ReferenceEvent.TAG_ADD]: {
    verbs: 'added',
    icon: { name: 'local_offer', color: 'success' },
    tagColor: 'primary',
    strike: false,
  },
  [ReferenceEvent.TAG_REMOVE]: {
    verbs: 'removed',
    icon: { name: 'local_offer', color: 'error' },
    tagColor: 'grey darken-2',
    strike: true,
  },
};

export default {
  name: 'TagEventLogItem',
  components: { BaseEventLogItem, ReferenceTagChip },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    reference: {
      type: Reference,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    verbs() {
      return this.styleProps.verbs;
    },
    icon() {
      return this.styleProps.icon.name;
    },
    iconColor() {
      return this.styleProps.icon.color;
    },
    strike() {
      return this.styleProps.strike;
    },
    tagColor() {
      return this.styleProps.tagColor;
    },
    tagLabel() {
      return this.referenceEventLog.payload.tagText;
    },
    styleProps() {
      return EVENT_TO_STYLE_PROPS[this.referenceEventLog.event];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
